<template>
  <div>
    <v-container fluid class="white elevation-3 margen d-flex justify-space-between">
      <v-row class="d-flex  justify-space-between">
        <v-col cols="12" sm="12" md="3" class="my-auto d-flex">
          <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/Dashboard">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h1>Órdenes de compra activas</h1>
        </v-col>
      </v-row>
    </v-container>

    

    <v-container fluid class="mt-3 pa-2 white margen">
      <div class="d-flex justify-space-between">
        <div class="d-flex">
          <span class="text-h5 mx-3">Información.</span>
        </div>
      </div>

      <!-- <v-card :disabled="editar" class="ma-3 pa-3"> -->
      <v-card :disabled="false" class="ma-3 pa-3">

        <v-divider></v-divider>

        <!-- SECCION ORDENES -->
        <div class="my-2">
          <div class="text-h6 mx-3 d-flex justify-center ma-1">
            <span class="mouse noselect" v-ripple @click="mostrarOrdenes=!mostrarOrdenes">
            Órdenes activas
            <v-icon dense light>
              {{ iconoFlecha }}
              </v-icon>
            </span>
          </div>

          <v-alert v-if="cargandoCheck" class="yellow lighten-3 d-flex justify-center">
            <span class="text--white">Cargando...</span>
          </v-alert>

          <transition name="fade">
            <v-expansion-panels accordion v-if="mostrarOrdenes"
             class="elevation-1 justify-start"
             focusable 
             multiple>
             <v-card-title style="width:100%;" class="grey lighten-1">
                <!-- <div> :
                  <span class="subtitle-1 d-flex" style="display:block; word-break:break-word!important;"> 
                    
                  </span>
                </div> -->
                
             </v-card-title>

              <div>
                
              </div>
              <v-expansion-panel v-for="ordenCompra in ordenesCompras" :key="ordenCompra.ORDEN_COMPRA_ID">
                  
                <v-expansion-panel-header expand-icon="mdi-menu-down" class="d-flex">
                  <v-row>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold">{{ordenCompra.FOLIO}}                   </v-col>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold" style="text-align:right;">Artículos de la orden                            </v-col>
                  </v-row>
                </v-expansion-panel-header>
                
                <v-expansion-panel-content 
                class="mouse borde"
                >
                    <!-- {{articulosSeleccionados}} -->
                    <v-data-table :id="ordenCompra.ORDEN_COMPRA_ID"
                    :headers="columnasOrdenes"
                    :items="ordenCompra.ARTICULOS"
                    item-key="ORDEN_COMPRA_DETALLE_ID"
                    v-model="articulosSeleccionados"
                    item-class="allB"
                    @input="log"
                    hide-default-footer
                    disable-pagination
                    >
                      <template v-slot:[`item.actionCantCheckIn`]="{ item }">
                        <div>
                          <v-text-field label="Cantidad confirmada" v-model="item.CANTIDAD_ALMACEN" :min="item.CANTIDAD_MINIMA" :max="item.CANTIDAD_RECIBIDA" type="number" dense solo hide-details="" />
                        </div>
                      </template>

                      <template slot="no-data">
                        <v-alert class="my-2" :value="true" type="info" color="orange lighten-2" >
                          No se encontró información para mostrar.
                        </v-alert>
                      </template>

                    </v-data-table>
                        
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </transition >

        </div>
        <!-- FIN SECCION PRODUCTOS -->

        <v-divider></v-divider>

        <div class="d-flex justify-center mb-2">
          <v-btn class="mx-3 colorP darken-1" 
            dark small text :loading="cargandoCheck" @click="GuardarCambios">
              Guardar Cambios
          </v-btn>
        </div>

      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    data() {
        return{
            //Datos para almacenar los proveedores y sus artículos
            ordenesCompras: [],
            //proveedoresUnicos:[],
            //proveedoresSeleccionados:[],
            articulosSeleccionados: [],
            mostrarOrdenes: false,
            mostrarSnackbar: false,
            mensajeSnack: '',
            colorSnack: '',
            cargandoCheck: false,
            modalFecha: false,
            columnasOrdenes:[
                {text:"Nombre", value:"NOMBRE"},
                {text:"Cantidad recibida", value:"CANTIDAD_RECIBIDA"},
                {text:"Confirma cantidad almacén", value:"actionCantCheckIn"},
            ],
        };
    },
    computed: {
        ...mapGetters(["getURLAPI","getUsuario","getFechaActual"]),

        iconoFlecha : function() {
        return this.mostrarOrdenes ? "mdi-arrow-up-drop-circle":"mdi-arrow-down-drop-circle"
        },
    },
    methods: {
        async getOrdenes(){
            this.cargandoCheck = true;
            //let cont = 1;
            try{
                this.ordenesCompras = (await axios.get(`${this.getURLAPI}/Ordenes/getOrdenesCheckIn`)).data;
                console.log(this.ordenesCompras);

                for(const ordenCompra of this.ordenesCompras){
                    ordenCompra.ARTICULOS = (
                        await axios.get(`${this.getURLAPI}/Ordenes/getOrdenesDetalleCheckIn/${ordenCompra.ORDEN_COMPRA_ID}`)
                    ).data
                    ordenCompra.ARTICULOS.forEach(element => {
                      element.CANTIDAD_MINIMA = element.CANTIDAD_ALMACEN;
                      //cont++;
                    });
                }
                console.log(this.ordenesCompras);
                this.mostrarOrdenes = true;
                this.cargandoCheck = false;
            }
            catch( err ){
                console.log(err);
            }
        },
        snackbar( data ){
        this.mostrarSnackbar = true;
        this.mensajeSnack = data.MSG;
        
        if ( data.STATUS !== "ERROR" ) {
            this.colorSnack = 'success darken-1'
        }
        else{
            this.colorSnack = 'red lighten-1'
        }
        },

        onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        },

        GuardarCambios(){
            this.cargandoCheck = true;
            console.log(this.ordenesCompras);

            let datosForm = new FormData();
            datosForm.append("ORDENES_COMPRAS", JSON.stringify(this.ordenesCompras));

            axios.post(`${this.getURLAPI}/Ordenes/guardarCambiosCheckIn`,datosForm)
            .then( ({data}) => {
              console.log(data);
              this.getOrdenes();
              this.$root.vtoast.show({ 
                        message: data.MSG,  color: data.STATUS=="OK" ? 'success darken-2':'red darken-2', 
                        timer:10000,        icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' } 
                    )
            })
            .catch( () =>{
              this.cargandoCheck = false
              this.$root.vtoast.show(
                      { message: "Error con el servidor",  color:'red darken-2', 
                        timer:10000,        icon: 'mdi-alert-circle-outline' } 
                  )
            }) 
            this.cargandoCheck = false;
        },
        
        log(){
          console.log(this.ordenesCompras);
            // for(let i = 0; i<this.articulosSeleccionados.length; i++){
            //     console.log(this.articulosSeleccionados[i]);
            // }
        }
    },

    created() {
        document.title = "Check-In de órdenes.";
        //this.minFecha = this.getFechaActual.split(" ");
        this.getOrdenes();
    }
}
</script>

<style>

</style>